// extracted by mini-css-extract-plugin
export const navigation = "navigation-module--navigation--tCgAu";
export const navigationItem = "navigation-module--navigationItem--3NUGy";